import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { format, eachDayOfInterval, isToday, isFuture } from "date-fns";
import { ChevronLeft, ChevronRight } from "styled-icons/boxicons-regular";
import { Row, Col } from "styled-bootstrap-grid";
import styled from "styled-components";
import ProfilePic from "../../Header/profile-pic-header.png";
import ClickOutside from "react-simple-click-outside";
import ProgressBar from "react-bootstrap/ProgressBar";
import {
  TimeConverstion,
  dateFormat,
} from "../../../../Api/Utils/ReuseableFunctions";
import { withTranslation, Trans } from "react-i18next";
import { showModal, hideModal } from "../../../../Actions";
import CalloutIcon from "../../../Shared/DateHeader/add comments.svg";
class WeekView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      weekStart: undefined,
      weekEnd: undefined,
      weekDataValues: undefined,
      standbyCss: {},
      heightSet: 0,
      showModal: false,
    };
    this.days = [];
    this.standByEndDate = null;
    this.standByStartDate = null;
    this.techssoId = null;
    this.applyStandByButton = React.createRef();
    this.weekContainer = this.weekContainer.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }
  componentDidMount() {
    if (this.props.weekData !== void 0) {
      this.setState({
        weekDataValues: this.props.weekData,
        weekStart: this.props.startDate,
        weekEnd: this.props.endDate,
      });
      this.updateDimensions();
      window.addEventListener("resize", this.updateDimensions);
    }
  }
  updateDimensions() {
    this.setState({ heightSet: document.body.scrollHeight });
  }
  componentDidUpdate(nextProps) {
    if (this.props.weekData !== nextProps.weekData) {
      this.setState({
        weekDataValues: this.props.weekData,
        weekStart: this.props.startDate,
        weekEnd: this.props.endDate,
      });
      this.updateDimensions();
      this.setState({ showModal: false });
    }
  }
  _close = () => {
    this.setState({
      standbyCss: { display: "none" },
    });
  };
  weekView = () => {
    return (
      <ParentDiv>
        <ButtonLeft
          type="submit"
          onClick={() => {
            this.props.weekAction("previous");
          }}
        >
          {" "}
          <Caretleft size="24" />
        </ButtonLeft>
        <span>
          {format(this.state.weekStart, "dd")}{" "}
          <Trans>{format(this.state.weekStart, "MMM").toLowerCase()}</Trans> -{" "}
          {format(this.state.weekEnd, "dd")}{" "}
          <Trans>{format(this.state.weekEnd, "MMM").toLowerCase()}</Trans>{" "}
          {format(this.state.weekEnd, "yyyy")}
        </span>
        {/* {!isFuture(this.state.weekEnd) && (
          <ButtonRight type="submit" onClick={this.nextWeek}>
            <Caretright size="24" />
          </ButtonRight>
        )} */}
        <ButtonRight
          type="submit"
          onClick={() => {
            this.props.weekAction("next");
          }}
        >
          <Caretright size="24" />
        </ButtonRight>
        <span>{this.weekContainer()}</span>
      </ParentDiv>
    );
  };
  openStandByMenu = (employeeData, index, e) => {
    this.techssoId = employeeData.ssoId;
    this.standByEndDate = employeeData.standByEndDate;
    this.standByStartDate = employeeData.standByStartDate;
    let elemntPos = this.days[index].getBoundingClientRect();
    var divStyle = {
      top: elemntPos.top + 40,
      left: elemntPos.left,
      display: "block",
    };
    this.setState({ standbyCss: divStyle });
  };

  weekContainer() {
    var start = this.state.weekStart;
    var end = this.state.weekEnd;
    var array = eachDayOfInterval({ start, end });
    var isWeekData =
      format(start, "dd/MM/yyyy") === this.state.weekDataValues.fromDate &&
      format(end, "dd/MM/yyyy") === this.state.weekDataValues.toDate;
    var updatedHt = this.state.heightSet - 278;
    const empDivStyle = {
      maxHeight: updatedHt + "px",
    };

    return (
      <>
        <WeekdaysDiv>
          <RowMain>
            <EmployeeCol md="2" />
            <Col md="9">
              {array.map((days) => (
                <WeekDaysName key={days}>
                  <ColInner sm="1">
                    <WeekDays>
                      <WeekDate value={isToday(days)}>
                        {format(days, "dd")}{" "}
                      </WeekDate>
                      <Trans>{format(days, "eee").toLowerCase()}</Trans>{" "}
                    </WeekDays>
                  </ColInner>
                </WeekDaysName>
              ))}
            </Col>
          </RowMain>
          <ClickOutside close={this._close} target="hidden">
            <AllEmployeeDataDiv style={empDivStyle}>
              {this.state.weekDataValues.employeeDetails.map(
                (employeeData, index) => {
                  let boundOpenStandByMenu = this.openStandByMenu.bind(
                    this,
                    {
                      ssoId: employeeData.ssoId,
                      standByEndDate: employeeData.standByEndDate,
                      standByStartDate: employeeData.standByStartDate,
                    },
                    index
                  );
                  return (
                    <RowMainDiv key={employeeData.ssoId}>
                      <EmployeeCol md="2">
                        <EmployeeNameDiv
                          ref={(ref) => (this.days[index] = ref)}
                          onClick={boundOpenStandByMenu}
                        >
                          <img src={ProfilePic} alt="profilepic" />
                          <span style={{ padding: "5px" }} />
                          {employeeData.firstName} {"  "}{" "}
                          {employeeData.lastName}
                        </EmployeeNameDiv>
                      </EmployeeCol>

                      {isWeekData
                        ? employeeData.otherDetails.map((othersData, i) => {
                            let uniqueIndex =
                              employeeData.otherDetails.length * index + i;
                            let { standByText } = this.returnStandBy(
                              othersData,
                              i,
                              employeeData.otherDetails,
                              this.standByStartDate
                            );
                            return (
                              <EmployeeDataDiv
                                Approved={othersData.isApproved}
                                Holiday={othersData.isHoliday}
                                Absent={othersData.isAbsent}
                                Hold={othersData.isOnHold}
                                isMissing={
                                  othersData.isTimesheetMissing === "Y"
                                }
                                key={uniqueIndex}
                              >
                                <EmployeeDiv
                                  isStandBy={othersData.isStandBy}
                                  className="employee-Div"
                                  onClick={() => {
                                  console.log("On Approve timesheet clicked props", this.props);
                                  console.log("On Approve timesheet clicked props history before", this.props.history);
                                 dateFormat(othersData.timesheetDate)>=dateFormat(employeeData.startDate)&&
                           ( dateFormat(othersData.timesheetDate)<=dateFormat(employeeData.endDate) || !employeeData.endDate )&&
                                    !isFuture(
                                      dateFormat(othersData.timesheetDate) 
                                    ) 
                                    &&
                                      this.props.history.push(
                                        employeeData.ssoId +
                                          "/techniciandetails",
                                        {
                                          date: othersData.timesheetDate,
                                          firstName: employeeData.firstName,
                                          startDate: dateFormat(employeeData.startDate),
                                          endDate: dateFormat(employeeData.endDate)
                                          
                                        }
                                      );
                                      console.log("On Approve timesheet clicked props history after", this.props.history);
                                  }}
                                >
                            
                                  {othersData.callOuts === "Y" && (
                                    <CallOutIcon>
                                      <img
                                        src={CalloutIcon}
                                        alt={"callouts"}
                                      />
                                    </CallOutIcon>
                                  )}
                                  {othersData.totalAddntlCallOutHours ? (
                                    <HourSpan>
                                      {TimeConverstion(
                                        othersData.totalAddntlCallOutHours
                                      )}
                                    </HourSpan>
                                  ) : null}
                                  {othersData.isHoliday === "Y" && (
                                    <Holiday>
                                      <Trans>publicHoliday</Trans>
                                    </Holiday>
                                  )}
                                  {othersData.isAbsent === "Y" && (
                                    <Holiday>
                                      <Trans>{othersData.absenceType}</Trans>
                                    </Holiday>
                                  )}
                                </EmployeeDiv>
                                {othersData.isStandBy === "Y" && (
                                  <div
                                    onClick={() => {
                                      if (othersData.isApproved === "N")
                                        this.props.applyStandBy(
                                          {
                                            standById: othersData.standById,
                                          },
                                          employeeData.ssoId
                                        );
                                    }}
                                    className="employee-Standby"
                                  >
                                    <Onstandby>
                                      {!standByText && (
                                        <StandbySpan>
                                          <Trans>standBy</Trans>
                                        </StandbySpan>
                                      )}
                                      <Progressbar
                                        striped
                                        variant="warning"
                                        now={100}
                                        // onClick={}
                                      />
                                    </Onstandby>
                                  </div>
                                )}
                              </EmployeeDataDiv>
                            );
                          })
                        : array.map((days, i) => {
                            let uniqueIndex =
                              employeeData.otherDetails.length * index + i;
                            let boundOpenStandByMenu = this.openStandByMenu.bind(
                              this,
                              days,
                              uniqueIndex
                            );
                            return (
                              <EmployeeDataDiv
                                key={format(days, "MM/dd/yyyy")}
                                ref={(ref) => (this.days[uniqueIndex] = ref)}
                                onClick={boundOpenStandByMenu}
                              >
                                <Col />
                              </EmployeeDataDiv>
                            );
                          })}
                    </RowMainDiv>
                  );
                }
              )}
            </AllEmployeeDataDiv>
          </ClickOutside>
        </WeekdaysDiv>

        <FooterData>
          <ApproveButton
            disabled={this.state.weekDataValues.isApprovalAllEnabled === "N"}
            onClick={this.props.approveData}
          >
            <Trans>approveAll</Trans>
          </ApproveButton>
        </FooterData>
        <ApplyButton
          style={this.state.standbyCss}
          ref={this.applyStandByButton}
          onClick={() =>
            this.props.applyStandBy(
              {
                standById: undefined,
              },
              this.techssoId
            )
          }
        >
          {<Trans>applyStandby</Trans>}
        </ApplyButton>
      </>
    );
  }
  returnStandBy = (dateObj, dayindex, calenderData) => {
    let standByText = dateObj
      ? dayindex !== 0
        ? calenderData[dayindex - 1].isStandBy === "Y"
          ? true
          : false
        : false
      : false;
    return { standByText: standByText };
  };
  render() {
    return (
      <>{this.state.weekDataValues !== void 0 ? this.weekView() : <div />}</>
    );
  }
}
const mapStateToProps = ({ auth, userMessage, managerTimesheetData }) => {
  return {
    isAuthenticated: auth.isAuthenticated,
    ssoId: auth.ssoId,
    message: userMessage,
    branchId: auth.user ? auth.user.defaultProfile.branchId : null,
    userDefault: auth.user.defaultProfile,
    weekData: managerTimesheetData.payload.weekDataDetails,
  };
};
const mapDispatchToProps = (dispatch) => ({
  hideModal: () => dispatch(hideModal()),
  showModal: (modalProps, template) => {
    dispatch(showModal({ modalProps, template }));
  },
});
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(WeekView))
);

const AllEmployeeDataDiv = styled.div`
  overflow-y: auto;
  .employee-Standby {
    height: 14px;
    position: relative;
    width: 100%;
    top: 21px;
  }
`;
const EmployeeDiv = styled.div`
height: ${(props) => (props.isStandBy === "Y" ? "75%" : "100%")}
width: 100%;
top: 0px;
position: absolute;
`;
const WeekdaysDiv = styled.div`
  position: relative;
  top: 23px;
  font-family: Trebuchet MS;
`;
const WeekDaysName = styled.div`
  position: relative;
  min-height: 1px;
  display: inline-table;
  width: 13.5%;
  right: 2%;
`;
const WeekDate = styled.div`
  background: ${(props) => (props.value ? "#70b0f3" : "#FFFFFF")};
  color: ${(props) => (props.value ? "#FFFFFF" : "#000000")};
  margin-right: 10px;
  top: 1px;
  border-radius: 20px;
  height: 20px;
  width: 20px;
`;
const WeekDays = styled.div`
  display: flex;
  position: relative;
`;
const EmployeeDataDiv = styled.div`
  align-items: center;
  justify-content: center;
  min-height: 1px;
  display: flex;
  width: 10%;
  height: 58px;
  border: 1px solid #e8e8e8;
  background: ${(props) =>
    props.Hold === "Y"
      ? "#E65853"
      : props.Approved === "Y"
      ? "#80E29A"
      : props.Holiday === "Y"
      ? "#ABCCD4"
      : props.isMissing
      ? "orange"
      : props.Absent === "Y"
      ? "#FFFFFF"
      : "#FFFFFF"};
  cursor: pointer;
  text-align: center;
  font-weight: bold;
  position: relative;
  flex-direction: column;
`;
const CallOutIcon = styled.div`
  height: 20px;
  float: right;
  width: 20px;
  padding-top: 4%;
`;
const Caretleft = styled(ChevronLeft)`
  position: relative;
  right: 8px;
  bottom: 4px;
  background: #b7b7b7;
  border-radius: 20px;
`;
const Caretright = styled(ChevronRight)`
  position: relative;
  right: 8px;
  bottom: 4px;
  background: #b7b7b7;
  border-radius: 20px;
`;
const ButtonLeft = styled.button`
  position: relative;
  right: 17px;
  top: 2px;
  border-radius: 20px;
  height: 24px;
  width: 24px;
`;
const ButtonRight = styled.button`
  position: relative;
  left: 17px;
  top: 2px;
  border-radius: 20px;
  height: 24px;
  width: 24px;
`;
const RowMain = styled(Row)`
  margin-right: 0px;
  margin-left: 0px;
  font-size: 14px;
`;
const RowMainDiv = styled(Row)`
  margin: 0px;
  height: 57px;
  text-align: left;
`;
const EmployeeNameDiv = styled.div`
  top: 60%;
  left: 40%;
  color: #4a4a4a;
  font-size: 16px;
  cursor: pointer;
`;
const EmployeeCol = styled(Col)`
  padding-top: 10px;
  padding-left: 0px;
  padding-right: 0px;
  width: 16%;
  margin-left: 7%;
`;
const ColInner = styled(Col)`
  position: relative;
  min-height: 1px;
  display: flex;
`;
const ParentDiv = styled.div`
  font-family: Trebuchet MS;
  padding-top: 3px;
  font-size: 16px;
  width: 100%;
  text-align: center;
`;
const HourSpan = styled.div`
  width: 100%;
  position: absolute
  top:1px
`;
const Holiday = styled.div`
  font-size: 12px;
  padding-top: 20px;
`;
const ApproveButton = styled.button`
  background: ${(props) => (props.disabled ? "#b7b7b7" : "#c4151c")}
  border-radius: 30px;
  border: 1px solid #96989a;  
  height: 34px;
  width: 129px;
  position: relative;
  left: 8px;
  color: #ffffff
  border :none
  font-size: 12px;
  margin:0 10px;
`;
const FooterData = styled.div`
  border-top: 1px solid #babec3;
  background: #f1f4f9;
  height: 70px;
  padding-top: 15px;
  text-align: center;
  position:fixed
  right: 0px;
  width: 101%;
  margin-left: 4px;
  bottom:0px
`;
const ApplyButton = styled.button`
  background: #4a4a4a;
  position: fixed;
  color: white;
  font-size: 16px;
  font-family: Trebuchet MS;
  height: auto;
  padding-top: 1px;
  padding-left: 6px;
  width: auto;
  display: none;
  border: none;
`;
const Onstandby = styled.div``;
const StandbySpan = styled.span`
  position: absolute;
  font-size: 11px;
  left: 0;
`;
const Progressbar = styled(ProgressBar)`
  && {
    height: 14px;
    border-radius: 3px;
    margin: 0 -1px 0 -2px;
  }
`;
